export class PortfolioAnalysisStoreMappingConfig {
	public static readonly risk = [
		'sleeves',
		'scenarios',
		'risk',
		'tailRisk'
	];
	public static readonly details = [
		'portfolioBreakdowns',
		'characteristics',
		'sleeves',
		'customColumns',
		'ruleEvaluations',
		'esgScores' // used in nile
	];
	public static readonly scenarioTesterDetails = [
		'characteristics'
	];

	public static readonly performance = [
		'performance',
		'sleeves'
	];

	public static readonly performanceExBenchmark = [
		'performance',
		'sleeves'
	];

	public static readonly performanceCommonPeriods = [
		'performance',
		'sleeves'
	];

	public static readonly wealthProjections = [
		'wealthProjection'
	];

	public static readonly esg = [
		'esgScores'
	];

	public static readonly fundAnalytics = [
		'fundAnalytics',
		'performance',
		'risk'
	];
	public static readonly rules = [
		'ruleEvaluations'
	];
}
